<template>
  <div class="stripe-income-page" v-if="enabledTabList[activeTabIndex]">
      <app-back-button
        class="team-view-page__top__buttons__back__button"
      />

    <app-stripe-charge-list-page 
      v-if="enabledTabList[activeTabIndex].type === 'charges'" 
    />
    <app-stripe-payout-list-page 
      v-if="enabledTabList[activeTabIndex].type === 'payouts'" 
      :connectedAccountId="connectedAccountId"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StripeEnabledGuardMixin from '@modules/stripe/mixins/stripe-enabled-guard-mixin';
import StripeChargeListPage from '@modules/stripe/stripe-charge/components/stripe-charge-list-page.vue';
import StrinpePayoutListPage from '@modules/stripe/stripe-payout/components/stripe-payout-list-page.vue';

export default {
  name: 'app-stripe-income-page',

  props: ['id', 'tabName'],

  mixins: [StripeEnabledGuardMixin],

  computed: {
    ...mapGetters({
      tabs: 'stripeIncome/tabs',
      activeTabIndex: 'layout/headerTabs/activeTabIndex',
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      connectedAccountId: 'auth/manage/connectedAccountId',
    }),

    enabledTabList() {
      return Object.values(this.tabs).filter((elem) => {
        return elem.isDisabled == false;
      });
    },
  },

  mounted() {
    this.setTabs(this.enabledTabList);
    this.parseActiveTab();
  },

  methods: {
    ...mapActions({
      doFind: 'player/view/doFind',
      setTabs: 'layout/headerTabs/setTabs',
      setActiveTabIndex:
        'layout/headerTabs/setActiveTabIndex',
    }),

    parseActiveTab() {
      var activeTabIndex = this.activeTabIndex || 0;

      if (this.tabName) {
        activeTabIndex = this.enabledTabList.findIndex(
          ({ type }) => type == this.tabName,
        );
      }
      this.setActiveTabIndex(activeTabIndex);
    },
  },

  components: {
    [StripeChargeListPage.name]: StripeChargeListPage,
    [StrinpePayoutListPage.name]: StrinpePayoutListPage,
  },
};
</script>


<style scoped>
</style>

